import { GetLoadables } from './loader';
// #if process.env.UIX_CHUNKED === 'true'
let loader = ()=>{
    return import(/* webpackChunkName: 'rreflex' */ './rreflexLoad');
};
const L = GetLoadables(loader, [
    'ReflexContainer',
    'ReflexSplitter',
    'ReflexElement'
]);
// #endif
// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './rreflexLoad'
// #endif
export let { ReflexContainer, ReflexSplitter, ReflexElement } = L;
